import React from "react";
import BlockUi from "react-block-ui";
import { JdsTag } from "../../../components/jds/JdsTag";
import CalculatorApiTabs from "./CalculatorApiTabs";
import UsageFilters from "./UsageFilters";
import UsageSubTabs from "./UsageSubTabs";
import UsageTable from "./UsageTable";
import { useUsageTab } from "./useUsageTab";
import { clientLabelOf } from "../utils/clientLabel";
import { formatPeriod } from "../utils/formatPeriod";
import "../../../components/jds/jds.css";
import "../calculatorApi.css";

// O corpo das sub-abas de consumo da Listagem. Cálculos e Consultas só trocam a
// rota chamada, o mapa de labels e o rótulo da coluna de quebra — o resto é
// idêntico, então mora aqui em vez de ser copiado em dois arquivos.
export default function UsageTab({ fetchUsage, labels, breakdownLabel }) {
  const {
    clients,
    clientsError,
    formFilters,
    appliedFilters,
    setFormFilters,
    applyFilters,
    usage,
    usageError,
    usageLoading,
    byClientRows,
    breakdownRows,
  } = useUsageTab({ fetchUsage, labels });

  const period = usage && formatPeriod(usage.period);

  return (
    <div className="jds-scope">
      <CalculatorApiTabs />

      <div className="jds-card">
        <UsageSubTabs />

        <UsageFilters
          clients={clients}
          clientsError={clientsError}
          formFilters={formFilters}
          appliedFilters={appliedFilters}
          setFormFilters={setFormFilters}
          onApply={applyFilters}
        />

        {usageError && (
          <div className="ca-alert" role="alert">
            {usageError}
          </div>
        )}

        <BlockUi tag="div" blocking={usageLoading}>
          {!usageError && !usage && (
            <p className="text-muted">Nenhum consumo via API B2B no período.</p>
          )}

          {!usageError && usage && (
            <>
              {(period || usage.client) && (
                <div className="ca-meta">
                  {period && (
                    <p className="ca-meta__item">
                      Período apurado: <JdsTag label={period} color="info" />
                    </p>
                  )}

                  {/* exatamente uma das duas dimensões vem: `client` quando há
                      filtro de cliente, `byClient` no consolidado */}
                  {usage.client && (
                    <p className="ca-meta__item">
                      Cliente:{" "}
                      <JdsTag
                        label={clientLabelOf(usage.client)}
                        color="info"
                      />
                    </p>
                  )}
                </div>
              )}

              {usage.byClient && (
                <>
                  <h2 className="jds-title-sm ca-section-title">Por cliente</h2>
                  <UsageTable
                    rowLabel="Cliente"
                    rows={byClientRows}
                    totals={usage.totals}
                  />
                </>
              )}

              <h2 className="jds-title-sm ca-section-title">
                Por {breakdownLabel.toLowerCase()}
              </h2>
              <UsageTable
                rowLabel={breakdownLabel}
                rows={breakdownRows}
                totals={usage.totals}
              />
            </>
          )}
        </BlockUi>
      </div>
    </div>
  );
}
